/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

/* OFFLINE MAP ROUTES */
export default [
  {
    name: routeNames.OFFLINE_FISH,
    path: 'offline',
    component: () => import('@/components/offline-card'),
  },
  {
    name: 'offline-create-fish',
    path: 'offline/create',
    component: () => import('@/components/offline-create-card'),
    children: [
      {
        name: 'offline-create-card-form-fish',
        path: '',
        component: () => import('@/components/offline-create-card-form'),
      },
      {
        name: 'offline-create-card-details-fish',
        path: 'imagery-details',
        component: () => import('@/components/offline-create-card-details'),
      },
    ],
  },
  {
    name: 'offline-details-fish',
    path: 'offline/details/:id',
    component: () => import('@/components/offline-details-card'),
  },
  {
    name: 'offline-details-edit-fish',
    path: 'offline/details/:id/edit',
    component: () => import('@/components/offline-details-card'),
    props: { edit: true },
  },
]
